import React, { useEffect, useState, useRef } from "react";
import {
    ToggleChat,
    ToggleAudio,
    ToggleVideo,
    ToggleSpeaker,
    SendCommandOnce,
} from "./actions";
import { connect } from "./../../../base/redux";
import { getLocalVideoTrack, isLocalTrackMuted } from "../../../base/tracks";
import { MEDIA_TYPE } from "../../../base/media";
import {
    getSessionStatusToShow,
    getActiveSession,
    RECORDING_TYPES,
} from "../../../recording";
import { JitsiRecordingConstants } from "../../../base/lib-jitsi-meet";
import {
    isLocalParticipantModerator,
    getLocalParticipant,
    participantUpdated,
} from "../../../base/participants";
import Button from "./Button";
import { NewMessageCount } from "./../Call/call_actions";
import swal from "sweetalert";
import {
    sendAnalytics,
    createRecordingDialogEvent,
    createToolbarEvent,
    ACTION_SHORTCUT_TRIGGERED,
} from "../../../analytics";
import {
    isScreenVideoShared,
    startScreenShareFlow,
} from "../../../screen-share";
import { VIRTUAL_BACKGROUND_TYPE } from "../../../virtual-background/constants";
import { toggleBackgroundEffect } from "../../../virtual-background";
import { ReactionEmoji } from "../../../reactions/components";

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

function Toolbox(props) {
    const [speaker_off, setSpeakerOff] = useState(false);
    const {
        additional_moderator,
        activate_guest_share_screen,
        screenShare,
        _audioMuted,
        _videoMuted,
        JoineeList,
        _status,
        _chatOpen,
        __isInitVideoMuted,
        __isInitAudioMuted,
        __notificationSent,
        _participants,
        _screenSharing,
        _getReactionsQueue,
        presenterMediaType,
    } = props;

    const MouseMoveHandler = (e) => {
        let x = e.offsetX;
        let y = e.offsetY;
    };

    const prevNotfSent = usePrevious(__notificationSent);
    let isScreenSharerVideoMuted = presenterMediaType?.muted ?? false;
    let isModerator =
        additional_moderator &&
        additional_moderator.includes(APP.conference.getMyUserId())
            ? true
            : false;
    let activeScreen =
        activate_guest_share_screen &&
        activate_guest_share_screen.includes(APP.conference.getMyUserId())
            ? true
            : false;

    useEffect(() => {
        window.$(".Vc-bottom-bar").draggable({
            handle: ".draggable_toolbox",
            containment: "#videoconference_page",
        });

        let element = document.getElementById("toolbar-manager");
        element.addEventListener("mousedown", function () {
            element.addEventListener("mousemove", MouseMoveHandler);
        });
        element.addEventListener("mouseup", function () {
            element.removeEventListener("mousemove", MouseMoveHandler);
        });
    }, []);

    useEffect(() => {
        if (props._chatOpen) {
            setTimeout(() => {
                APP.store.dispatch(NewMessageCount(0));
            });
        }
    }, [props._chatOpen]);

    useEffect(() => {
        if (prevNotfSent === false && __notificationSent) {
            if (__isInitVideoMuted || __isInitAudioMuted) {
                if (__isInitVideoMuted && !_videoMuted) {
                    OnVideoClick();
                }
                if (__isInitAudioMuted && !_audioMuted) {
                    OnAudioClick();
                }
                swal("Media is muted by host!");
            }
        }
    }, [__notificationSent]);

    const OnAudioClick = () => {
        ToggleAudio();
    };

    const OnVideoClick = () => {
        ToggleVideo();
    };

    const OnToggleScreen = () => {
        sendAnalytics(
            createToolbarEvent(
                "toggle.screen.sharing",
                ACTION_SHORTCUT_TRIGGERED,
                { enable: !_screenSharing }
            )
        );
        _doToggleScreenshare();
    };

    /**
     * Dispatches an action to toggle screensharing.
     *
     * @private
     * @param {boolean} enabled - The state to toggle screen sharing to.
     * @param {boolean} audioOnly - Only share system audio.
     * @returns {void}
     */
    function _doToggleScreenshare() {
        const {
            _backgroundType,
            _desktopSharingEnabled,
            _localVideo,
            _virtualSource,
        } = props;

        if (_backgroundType === VIRTUAL_BACKGROUND_TYPE.DESKTOP_SHARE) {
            const noneOptions = {
                enabled: false,
                backgroundType: VIRTUAL_BACKGROUND_TYPE.NONE,
                selectedThumbnail: VIRTUAL_BACKGROUND_TYPE.NONE,
                backgroundEffectEnabled: false,
            };

            _virtualSource.dispose();

            APP.store.dispatch(
                toggleBackgroundEffect(noneOptions, _localVideo)
            );

            return;
        }

        if (_desktopSharingEnabled) {
            APP.store.dispatch(startScreenShareFlow());
        }
    }

    const onToggleChat = () => {
        ToggleChat();
        window.$(".right-chat-1").removeClass("d-none");
    };

    const onToggleSpeaker = () => {
        ToggleSpeaker(speaker_off ? true : false);
        setSpeakerOff(speaker_off ? false : true);
    }; 

    const onRaiseHand = () => {
        const enable = !props._raisedHand;
        APP.store.dispatch(
            participantUpdated({
                id: props._localParticipant.id,
                local: true,
                raisedHand: enable,
            })
        );
    };

    const onRecording = (status) => {
        if (status === "on") {
            swal({
                title: "Warning!",
                text: "Do you want to stop recording?",
                icon: "warning",
                closeOnClickOutside: false,
                buttons: { cancel: true, confirm: true },
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    sendAnalytics(
                        createRecordingDialogEvent("stop", "confirm.button")
                    );
                    const { _fileRecordingSession } = props;
                    if (_fileRecordingSession) {
                        props._conference.stopRecording(
                            _fileRecordingSession.id
                        );
                    }
                    SendCommandOnce(
                        "recording-on-off",
                        JSON.stringify({
                            id: APP.conference.getMyUserId(),
                            recordingOn: false,
                        })
                    );
                    return true;
                }
            });
        } else {
            swal({
                title: "Warning!",
                text: "Do you want to start recording?",
                icon: "warning",
                closeOnClickOutside: false,
                buttons: { cancel: true, confirm: true },
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    const { _autoCaptionOnRecord, _conference } = props;
                    let appData;
                    const attributes = {};

                    appData = JSON.stringify({
                        file_recording_metadata: {
                            share: true,
                        },
                    });

                    attributes.type = RECORDING_TYPES.JITSI_REC_SERVICE;

                    sendAnalytics(
                        createRecordingDialogEvent(
                            "start",
                            "confirm.button",
                            attributes
                        )
                    );

                    _conference.startRecording({
                        mode: JitsiRecordingConstants.mode.FILE,
                        appData,
                    });

                    SendCommandOnce(
                        "recording-on-off",
                        JSON.stringify({
                            id: APP.conference.getMyUserId(),
                            recordingOn: true,
                        })
                    );

                    if (_autoCaptionOnRecord) {
                        dispatch(toggleRequestingSubtitles());
                    }
                    return true;
                }
            });
        }
    };

    return (
        <div
            className="Vc-bottom-bar tools-bottom-bar d-flex justify-content-between"
            id="toolbar-manager"
        >
            <div className="bottom-side-img draggable_toolbox">
                {/* <span className="circle-bottom-bar"></span> */}
                <a href={void 0} className="circle-bottom-bar ">
                    <img src="public/assets/images/Ellipse 89.png" alt="1" />
                </a>
            </div>
            <div className="d-flex bottom-middle-img align-self-center draggable_toolbox">
                <ul className="navbar-nav">
                    {(!sessionStorage.getItem("userRole") ||
                        sessionStorage.getItem("userRole") !== "owner") &&
                        !isModerator && (
                            <Button
                                text="Raise Hand"
                                src={`public/assets/images/invite-white-hand.svg`}
                                action={onRaiseHand}
                                btn_id="raise_hand_btn"
                                active={false}
                            />
                        )}
                    {((sessionStorage.getItem("userRole") &&
                        sessionStorage.getItem("userRole") === "owner") ||
                        isModerator) && (
                        <Button
                            text="Recording"
                            src={
                                ["on", "pending"].includes(_status)
                                    ? _status
                                    : `public/assets/images/record-meet.svg`
                            }
                            action={() => onRecording(_status)}
                            btn_id="recording_btn"
                            active={_status === "on"}
                        />
                    )}
                    <Button
                        text="Volume"
                        src={`public/assets/images/${
                            speaker_off ? "speaker-down.svg" : "speaker-up.svg"
                        }`}
                        action={onToggleSpeaker}
                        btn_id="speaker_btn"
                        active={speaker_off}
                    />
                    <Button
                        text="Mute"
                        src={`public/assets/images/${
                            _audioMuted ? "bi_mic-mute.svg" : "bi_mic-umute.svg"
                        }`}
                        action={OnAudioClick}
                        btn_id="mute_btn"
                        active={_audioMuted}
                    />
                    <Button
                        text="Video"
                        src={`public/assets/images/${
                            _videoMuted || isScreenSharerVideoMuted
                                ? "video-meet-mute.svg"
                                : "video-meet.svg"
                        }`}
                        action={OnVideoClick}
                        btn_id="vid_mute_btn"
                        active={_videoMuted || isScreenSharerVideoMuted}
                    />
                    {_participants &&
                        _participants.length > 1 &&
                        (isModerator ||
                            activeScreen ||
                            sessionStorage.getItem("userRole") === "owner") && (
                            <Button
                                text="Share"
                                src={`public/assets/images/screen-share.svg`}
                                action={OnToggleScreen}
                                btn_id="share_btn"
                                active={screenShare}
                            />
                        )}
                    <Button
                        text="More"
                        src={`public/assets/images/more_icon.png`}
                        btn_id="more_btn"
                    />
                    <li
                        className={`nav-item webphone-btns chat-btn ${
                            _chatOpen ? "active" : ""
                        }`}
                        onClick={onToggleChat}
                    >
                        <a href={void 0} className="nav-link">
                            <img
                                src="public/assets/images/bi_chat-left-dots.svg"
                                alt="chat"
                            />
                            <span className="text-13">Chat</span>
                        </a>
                    </li>
                    <Button
                        text="Reaction"
                        src={`public/assets/images/emoji_reaction.png`}
                        btn_id="reaction_btn"
                    />
                    <Button
                        text="Participants"
                        src={`public/assets/images/participent.svg`}
                        action={() => $("#InviteModal").modal("show")}
                        btn_id="participants_btn"
                        active={JoineeList}
                        _participants={_participants?.length}
                    />
                    <Button
                        text="End"
                        src={`public/assets/images/end_call.png`}
                        btn_id="end_call"
                        active={false}
                        _participants={_participants}
                    />
                </ul>
                {_getReactionsQueue &&
                    _getReactionsQueue.map(({ reaction, uid }, index) => (
                        <ReactionEmoji
                            index={index}
                            key={uid}
                            reaction={reaction}
                            uid={uid}
                        />
                    ))}
            </div>
        </div>
    );
}
const _mapStateToProps = (state) => {
    const tracks = state["features/base/tracks"];
    const { conference } = state["features/base/conference"];
    const { hideLobbyButton } = state["features/base/config"];
    const _localParticipant = getLocalParticipant(state);
    const { autoCaptionOnRecord = false } = state["features/base/config"];
    const localVideo = getLocalVideoTrack(state["features/base/tracks"]);
    let desktopSharingEnabled = JitsiMeetJS.isDesktopSharingEnabled();
    let presenterMediaType =
        tracks && tracks.find((value) => value.mediaType === "presenter");
    return {
        _localParticipant,
        _raisedHand: _localParticipant.raisedHand,
        _lobbyEnabled: state["features/lobby"].lobbyEnabled,
        _visible:
            conference &&
            conference.isLobbySupported() &&
            isLocalParticipantModerator(state) &&
            !hideLobbyButton,
        _fileRecordingSession: getActiveSession(
            state,
            JitsiRecordingConstants.mode.FILE
        ),
        _chatOpen: state["features/chat"].isOpen,
        screenShare: APP?.conference?.isSharingScreen,
        invite_meet: state["features/nxatel_meet"].invite_meet,
        invite_lobby: state["features/nxatel_meet"].invite_lobby,
        _audioMuted: isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO),
        _videoMuted: isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO),
        _status: getSessionStatusToShow(
            state,
            JitsiRecordingConstants.mode.FILE
        ),
        _conference: state["features/base/conference"].conference,
        _autoCaptionOnRecord: autoCaptionOnRecord,
        activate_guest_share_screen:
            state["features/nxatel"].activate_guest_share_screen,
        additional_moderator: state["features/nxatel"].additional_moderator,
        _screenSharing: isScreenVideoShared(state),
        _backgroundType: state["features/virtual-background"].backgroundType,
        _desktopSharingEnabled: desktopSharingEnabled,
        _localVideo: localVideo,
        _virtualSource: state["features/virtual-background"].virtualSource,
        _getReactionsQueue: state["features/reactions"].queue,
        presenterMediaType,
    };
};
export default connect(_mapStateToProps)(Toolbox);
